import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { pushNotify } from '@appComponents/Notification/Notification';

export const newLineToParagraph = (text: string, italic: boolean = false) => {
  const newText = text.split(/\r\n|\r|\n/g).map((line, index) => (
    <p style={{ overflow: 'hidden', fontStyle: italic ? 'italic' : 'normal' }} key={index}>{line}</p>)
  );

  return newText;
};

interface IMyLink {
  to: string;
  className?: string;
  children: React.ReactNode;
  isReactLink?: boolean;
  target?: string;
  rel?: string;
}
export const MyLink = ({ to, className, children, isReactLink, ...rest }: IMyLink) => {
  if (isReactLink) {
    return <Link to={to} className={className} {...rest}>{children}</Link>;
  }

  return <a href={to} className={className} {...rest}>{children}</a>;
};

interface ICallApi { api: Function; children: any; }
export const CallApiOnRender = (props: ICallApi) => {
  useEffect(() => {
    props.api();
  }, []);

  return props.children;
};

export const renderLabel = (value: string|null|undefined, className: string) =>
  value && <label className={className} dangerouslySetInnerHTML={{ __html: value }} />;

export const classNames = (...args: (string|number|boolean|null|undefined)[]): string => {
  const classes: (string|number|boolean)[] = [];

  for (let i = 0 ; i < args.length ; i += 1) {
    const arg = args[i];
    if (!arg) continue;

    const argType = typeof arg;

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    }
  }

  return classes.join(' ');
};

export const compatibilityCheck = (elementList: string[]): boolean => {
  const compatibility = elementList.map(element => element in window);

  return !compatibility.includes(false);
};

export const unauthorizedPushNotification = (redirect?: Function, msg:string = 'Wrong URL address.') => {
  pushNotify('error', msg, 5000);
  if (redirect) redirect();
};

export const getObjectProperty = <T, K extends keyof T>(obj: T, key: K): string|number|Object|null|undefined => obj[key];
